import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IApiResponse,
  IGetUsuarioQueryParams,
  IListaPaginada,
  IPostUsuarioBody,
  IPostUsuarioResponseData,
  IPutUsuarioBody,
  IPutUsuarioResponseData,
  IUsuario
} from 'src/app/interfaces';
import { IAtivarOuDesativarUsuarioRouteParams } from 'src/app/interfaces/usuario/IAtivarOuDesativarUsuarioRouteParams';
import { IDeleteUsuarioRouteParams } from 'src/app/interfaces/usuario/IDeleteUsuarioRouteParams';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  private readonly baseURL = '/Usuario';
  constructor(private httpClient: HttpClient) {}

  getUsuario(body: IGetUsuarioQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<IUsuario>>>(
      `${this.baseURL}/ObterUsuarios`,
      body
    );
  }

  postUsuario(body: IPostUsuarioBody) {
    return this.httpClient.post<IApiResponse<IPostUsuarioResponseData>>(
      this.baseURL,
      body
    );
  }

  putUsuario(body: IPutUsuarioBody) {
    return this.httpClient.put<IApiResponse<IPutUsuarioResponseData>>(
      this.baseURL,
      body
    );
  }

  deleteUsuario({ idUsuario, usuarioId }: IDeleteUsuarioRouteParams) {
    return this.httpClient.delete<IApiResponse>(
      `${this.baseURL}/${idUsuario}/${usuarioId}`
    );
  }

  ativarOuDesativarUsuario(body: IAtivarOuDesativarUsuarioRouteParams) {
    return this.httpClient.post<IApiResponse>(`${this.baseURL}/Status`, body);
  }
}
